<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>订单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">订单编号:</div>
              <div class="flex1">
                <el-input type="number" placeholder="请输入内容" clearable v-model="queryInfo.id" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">国内运单号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.trackingNumberCn" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">用户ID:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small" @keyup.enter.native="searchList()"> </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">商品链接:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.taobaoUrl" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">下单开始日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </el-col>

            <el-col :span="6" class="display-row">
              <div class="query-title">下单结束日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">购买账号:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.buyAccountId" placeholder="请选择" size="small" clearable>
                  <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id"> </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">购买订单号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.buyOrderNumber" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">商品名:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.goodsName" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <el-row class="search-row" style="margin-bottom: -5px; margin-right: -10px">
          <el-col :span="24" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn lx-mb5 btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn lx-mb5 btn-blue" @click="searchList()">搜索</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive"
                >展开</el-button
              >
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive">收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          ref="multipleTable"
          :data="orderList"
          height="550"
          :header-cell-style="tableStyle.headerStyle"
          v-loading="isLoading"
          border
          stripe
          style="width: 100%"
          @expand-change="handleExpandChange"
          :row-key="getRowKey"
          :expand-row-keys="expandedRowKeys"
          @row-click="handleParentRowClick"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :ref="'childTable' + props.row.id"
                :data="props.row.orderLists"
                tooltip-effect="dark"
                style="width: 100%"
                border
                :header-cell-style="tableStyle.headerStyleC"
                :row-style="tableStyle.rowStyle"
                @select="tableSelect"
                @select-all="tableSelectAll"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" align="center" width="50"> </el-table-column>
                <el-table-column label="订单编号" prop="id" align="center" width="70"> </el-table-column>
                <el-table-column label="图片" prop="pictureUrl" align="center" width="90">
                  <template slot-scope="scope">
                    <img
                      @paste="onPasteUpload"
                      @click="imgclick(scope.row, scope.$index)"
                      v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0"
                      :src="scope.row.pictureUrl"
                      alt=""
                      class="list-image"
                    />
                    <img v-else @click="imgclick(scope.row, scope.$index)" src="@/assets/images/default.png" alt="" class="list-image" />
                    <el-button class="list-btn-four btn-blue" @click="toGoodsDetail(scope.row)"> 商品详情 </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="商品规格" align="center" width="134">
                  <template slot-scope="scope">
                    <el-form label-position="right" label-width="56px" :model="scope.row" size="mini">
                      <el-form-item v-if="scope.row.colour" label-width="13px">
                        <span style="display: block; width: 100%; text-align: left">{{ scope.row.colourCn || scope.row.colour }}</span>
                      </el-form-item>
                      <el-form-item v-if="scope.row.goodsSize" label-width="13px">
                        <span style="display: block; width: 100%; text-align: left">{{ scope.row.goodsSizeCn || scope.row.goodsSize }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column label="收货地址" align="center" width="170">
                  <template slot-scope="scope">
                    <el-form label-position="right" label-width="56px" :model="scope.row" size="mini">
                      <el-form-item label="收件人：" v-if="scope.row.colour">
                        <span style="display: block; width: 100%; text-align: left">{{ scope.row.receiver }}</span>
                      </el-form-item>
                      <el-form-item label="电话：" v-if="scope.row.goodsSize">
                        <span style="display: block; width: 100%; text-align: left">{{ scope.row.receiverPhone }}</span>
                      </el-form-item>
                      <el-form-item label="邮编：" v-if="scope.row.goodsSize">
                        <span style="display: block; width: 100%; text-align: left">{{ scope.row.zipCode }}</span>
                      </el-form-item>
                      <el-form-item label="地址：" v-if="scope.row.goodsSize">
                        <span style="display: block; width: 100%; text-align: left">{{ scope.row.receiverAddress }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column label="订单操作" align="center" width="90">
                  <template slot-scope="scope">
                    <el-button class="list-btn-four btn-blue" @click="toOrderDetail(scope.row)" v-if="scope.row.orderStatus != 1">详情</el-button>
                    <el-button v-if="showEditBtn(scope.row.orderStatus)" class="list-btn-four btn-deepblue" @click="toEditOrder(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      v-if="showSplitOrderBtn(scope.row)"
                      class="list-btn-four btn-deepblue"
                      @click="splitOrder(scope.row)"
                      v-show="scope.row.orderStatus != 1"
                    >
                      拆单</el-button
                    >
                    <el-button class="list-btn-four btn-blue" @click="remind(scope.row)"> 提醒 </el-button>
                    <el-button
                      class="list-btn-four btn-blue"
                      @click="handleOrder(scope.row, '1688')"
                      v-show="scope.row.orderStatus == 1 && scope.row?.taobaoUrl.includes('1688')"
                      v-if="scope.row.orderStatus != 1"
                    >
                      1688下单
                    </el-button>
                    <el-button
                      class="list-btn-four btn-blue"
                      @click="handleOrderTb(scope.row)"
                      v-show="scope.row.orderStatus == 1 && (scope.row?.taobaoUrl.includes('taobao') || scope.row?.taobaoUrl.includes('tmall'))"
                    >
                      淘宝下单
                    </el-button>
                    <el-button class="list-btn-four btn-blue" @click="buyout(scope.row)" v-show="scope.row.orderStatus == 1"> 购买完 </el-button>
                    <el-button
                      class="list-btn-four btn-blue"
                      @click="cancelPurchaseStatus(scope.row)"
                      v-show="scope.row.orderStatus == 2 || (scope.row.orderStatus == 0 && scope.row.agentFlag == 1)"
                    >
                      取消购买完
                    </el-button>
                    <el-button class="list-btn-four btn-blue" @click="cancelCheckIn(scope.row)" v-show="scope.row.orderStatus == 4">
                      取消收货
                    </el-button>
                    <el-button
                      class="list-btn-four btn-blue"
                      @click="cancelCheck(scope.row)"
                      v-show="scope.row.orderStatus == 88 || scope.row.orderStatus == 8"
                    >
                      取消检品
                    </el-button>
                    <el-button class="list-btn-four btn-blue" @click="Store(scope.row)" v-show="scope.row.orderStatus == 2"> 店铺发货 </el-button>
                    <el-button class="list-btn-four btn-blue" @click="cantBuy(scope.row)" v-show="scope.row.orderStatus == 1"> 无法购买 </el-button>
                    <el-button
                      class="list-btn-four btn-blue"
                      @click="returned(scope.row)"
                      v-show="scope.row.orderStatus == 0 || scope.row.orderStatus == 2"
                    >
                      退货
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="订单状态" prop="orderStatus" align="center" width="70">
                  <template slot-scope="scope">
                    {{ scope.row.orderStatus | orderStatusFilter }}
                  </template>
                </el-table-column>
                <el-table-column label="购买账号" prop="buyAccountId" align="center" width="120">
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.buyAccountId"
                      @change="quickSave(scope.row.buyAccountId, '4', scope.row)"
                      placeholder="请选择"
                      size="small"
                      clearable
                    >
                      <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id"> </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="购买订单号" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input
                      type="textarea"
                      maxlength="50"
                      @blur="quickSave(scope.row.buyOrderNumber, '3', scope.row, true)"
                      v-model="scope.row.buyOrderNumber"
                      :disabled="scope.row.orderStatus != 1 && scope.row.orderStatus != 2"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="中英文描述" align="center" width="130">
                  <template slot-scope="scope">
                    <el-input
                      type="textarea"
                      @change="quickSave(scope.row.productDesc, '0', scope.row)"
                      placeholder="请输入中文产品描述"
                      v-model="scope.row.productDesc"
                      size="small"
                    >
                    </el-input>
                    <el-input
                      style="padding-top: 5px"
                      type="textarea"
                      @change="quickSave(scope.row.productDescEn, '7', scope.row)"
                      placeholder="请输入英文产品描述"
                      v-model="scope.row.productDescEn"
                      size="small"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="国内物流" align="center" width="110">
                  <template slot-scope="scope">
                    <el-input
                      type="textarea"
                      maxlength="50"
                      @blur="trackingNumberChange(scope.row.trackingNumberCn, scope.row.id)"
                      v-model="scope.row.trackingNumberCn"
                    ></el-input>
                    <div class="overflowDot" :title="scope.row.cnLogisticsStatus">
                      {{ scope.row.cnLogisticsStatus }}
                    </div>
                    <div v-if="scope.row.arrivalTime"><span>到库日:</span> <br />{{ scope.row.arrivalTime }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="采购/检品工作签" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input
                      type="textarea"
                      @change="quickSave(scope.row.staffRemark, '5', scope.row)"
                      placeholder="请输入采购内容"
                      v-model="scope.row.staffRemark"
                      size="small"
                    >
                    </el-input>
                    <el-input
                      style="padding-top: 5px"
                      type="textarea"
                      @change="quickSave(scope.row.checkRemark, '6', scope.row)"
                      placeholder="请输入检品内容"
                      v-model="scope.row.checkRemark"
                      size="small"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="单价" prop="price" align="center" width="90">
                  <template slot-scope="scope">
                    <el-input
                      placeholder="单价"
                      :disabled="scope.row.orderStatus != 1"
                      @blur="quickSave(scope.row.price, '2', scope.row)"
                      v-model="scope.row.price"
                      type="tel"
                      :maxlength="12"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                    ></el-input>
                    <el-input
                      placeholder="实际购买价格"
                      v-model="scope.row.actualPrice"
                      type="tel"
                      :maxlength="10"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                      @blur="handelPrice(scope.row)"
                    ></el-input>
                    <el-input
                      placeholder="历史最低价"
                      readonly
                      v-model="scope.row.historyPrice"
                      type="tel"
                      :maxlength="10"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="总价格" align="center" width="100">
                  <template slot-scope="scope">
                    {{ getPrice(scope.row.price, scope.row.goodsCount) }}
                  </template>
                </el-table-column>
                <el-table-column label="中国运费" align="center" width="80">
                  <template slot-scope="scope">
                    <el-input placeholder="预估运费" disabled v-model="scope.row.preInlandFreight" type="tel" :maxlength="12" readonly></el-input>
                    <el-input
                      placeholder="实际运费"
                      @blur="quickSave(scope.row.chineseFreightFee, '1', scope.row)"
                      v-model="scope.row.chineseFreightFee"
                      type="tel"
                      :maxlength="12"
                      :disabled="
                        ['0', '4', '8', '48', '88', '16', '24', '28', '32', '36', '68', '40', '82', '26', '89', '52', '56', '72', '84'].includes(
                          scope.row.orderStatus
                        )
                      "
                      oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="代购手续费" align="center" width="83">
                  <template slot-scope="scope">
                    <el-input placeholder="预估代购手续费" disabled v-model="scope.row.preAgentServiceFee" :maxlength="12" readonly></el-input>
                    <el-input
                      placeholder="实际代购手续费"
                      disabled
                      v-model="scope.row.agentServiceFee"
                      :maxlength="12"
                      oninput="value=value.replace(/[^\d.]/g,'')"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="用户备注" align="center" width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.editTime" class="mark">
                      编辑:{{ scope.row.editTime | dateFormatToSecond }}
                      <i @click="handleCloseMark(scope.row.id, scope.$index)" class="el-icon-close"></i>
                    </div>
                    <el-input type="textarea" placeholder="" v-model="scope.row.customerRemark" size="small" disabled> </el-input>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" type="selection"> </el-table-column> -->
          <el-table-column type="index" label="序号" width="40" align="center"></el-table-column>
          <el-table-column
            v-for="(item, index) in ordersGroup"
            :key="index"
            align="center"
            :label="item.name"
            :prop="item.key"
            :width="item.width ? item.width : 'auto'"
            :min-width="item.minWidth ? item.minWidth : 'auto'"
          >
            <template v-slot="scope">
              <!-- 订单操作 -->
              <div v-if="item.key === 'handle'">
                <el-button class="list-btn-four btn-blue btn-action" @click="batchUpdatePurchaseStatus"> 批量购买完 </el-button>
                <el-button class="list-btn-four btn-blue btn-action" @click="cantBuyAll(scope.row)"> 批量无法购买 </el-button>
              </div>
              <!-- 中英文描述 -->
              <div v-else-if="item.key === 'productDesc'">
                <el-input
                  type="textarea"
                  @change="quickSaveAll(scope.row.productDesc, '0', scope.row)"
                  placeholder="请输入中文产品描述"
                  v-model="scope.row.productDesc"
                  size="small"
                >
                </el-input>
                <el-input
                  style="padding-top: 5px"
                  type="textarea"
                  @change="quickSaveAll(scope.row.productDescEn, '7', scope.row)"
                  placeholder="请输入英文产品描述"
                  v-model="scope.row.productDescEn"
                  size="small"
                >
                </el-input>
              </div>
              <!-- 中国运费 -->
              <div v-else-if="item.key === 'chineseFreightFee'">
                <el-input placeholder="预估运费" disabled v-model="scope.row.groupPreInlandFreight" type="tel" :maxlength="12" readonly></el-input>
                <el-input
                  placeholder="实际运费"
                  @blur="quickSave(scope.row.chineseFreightFee, '1', scope.row)"
                  v-model="scope.row.groupChineseFreightFee"
                  type="tel"
                  :maxlength="12"
                  disabled
                  oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
                ></el-input>
              </div>
              <!-- 用户信息 -->
              <div v-else-if="item.key === 'userInfo'">
                <div>
                  {{ scope.row.userName }}
                </div>
                <div style="margin-top: 10px">
                  {{ scope.row.realName }}
                </div>
                <div style="margin-top: 10px">
                  {{ scope.row.remarkCustomerName }}
                </div>
              </div>
              <!-- 商品总金额 -->
              <div v-else-if="item.key === 'sumPrice'">
                {{ scope.row.groupGoodsPrice }}
              </div>
              <!-- 用户备注 -->
              <div v-else-if="item.key === 'customerRemark'">
                <div v-if="scope.row.editTime" class="mark">
                  编辑:{{ scope.row.editTime | dateFormatToSecond }}
                  <i @click="handleCloseMark(scope.row.id, scope.$index)" class="el-icon-close"></i>
                </div>
                <el-input type="textarea" placeholder="" v-model="scope.row.customerRemark" size="small" disabled> </el-input>
              </div>
              <!-- 购买账号 -->
              <div v-else-if="item.key === 'buyAccountId'">
                <el-select
                  v-model="scope.row.buyAccountId"
                  @change="quickSaveAll(scope.row.buyAccountId, '4', scope.row)"
                  placeholder="请选择"
                  size="small"
                  clearable
                >
                  <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id"> </el-option>
                </el-select>
              </div>
              <!-- 国内物流 -->
              <div v-else-if="item.key === 'trackingNumberCn'">
                <el-input
                  maxlength="50"
                  @blur="trackingNumberChangeAll(scope.row.trackingNumberCn, scope.row)"
                  v-model="scope.row.trackingNumberCn"
                ></el-input>
                <div class="overflowDot" :title="scope.row.cnLogisticsStatus">
                  {{ scope.row.cnLogisticsStatus }}
                </div>
                <div v-if="scope.row.arrivalTime"><span>到库日:</span> <br />{{ scope.row.arrivalTime }}</div>
              </div>
              <!-- 工作签 -->
              <div v-else-if="item.key === 'staffRemark'">
                <el-input
                  type="textarea"
                  @change="quickSaveAll(scope.row.staffRemark, '5', scope.row)"
                  placeholder="请输入采购内容"
                  v-model="scope.row.staffRemark"
                  size="small"
                >
                </el-input>
                <el-input
                  style="padding-top: 5px"
                  type="textarea"
                  @change="quickSaveAll(scope.row.checkRemark, '6', scope.row)"
                  placeholder="请输入检品内容"
                  v-model="scope.row.checkRemark"
                  size="small"
                >
                </el-input>
              </div>
              <!-- 代购手续费 -->
              <div v-else-if="item.key === 'agentServiceFee'">
                <el-input placeholder="预估代购手续费" disabled v-model="scope.row.groupPreAgentServiceFee" :maxlength="12" readonly></el-input>
                <el-input
                  placeholder="实际代购手续费"
                  disabled
                  v-model="scope.row.groupAgentServiceFee"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                >
                </el-input>
              </div>
              <!-- 组合订单 -->
              <div v-else-if="item.key === 'orderGroup'">
                <el-tooltip :content="scope.row.goodsNameCn || scope.row.goodsName" placement="top" effect="light">
                  <span class="text-over">{{ scope.row.goodsNameCn || scope.row.goodsName }}</span>
                </el-tooltip>
                <div class="btn-row" style="margin-top: 10px">
                  <el-button class="list-btn-four btn-blue btn-action" @click="toGoodsDetail(scope.row)">
                    商品详情 ({{ scope.row.groupCount }})
                  </el-button>
                </div>
              </div>
              <!-- 商品数量 -->
              <div v-else-if="item.key === 'goodsCount'">x{{ scope.row.groupGoodsCount }}</div>
              <!-- 购买订单号 -->
              <div v-else-if="item.key === 'buyOrderNumber'">
                <el-input
                  maxlength="50"
                  @blur="quickSaveAll(scope.row.buyOrderNumber, '3', scope.row, true)"
                  v-model="scope.row.buyOrderNumber"
                  :disabled="scope.row.orderStatus != 1 && scope.row.orderStatus != 2"
                >
                </el-input>
              </div>
              <!-- 创建时间 -->
              <div v-else-if="item.key === 'createTime'">
                {{ scope.row.createTime | dateFormatToSecond }}
              </div>
              <span v-else>
                {{ scope.row[item.key] }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 拆单 -->
    <el-dialog title="拆单" :visible.sync="splitDialogVisible" width="90%" @close="splitDialogClosed">
      <el-row>
        <el-col :span="12" class="split-col">
          <el-form label-width="120px" class="demo-ruleForm">
            <div class="split-title">原订单信息：</div>
            <div>
              <el-form-item label="原订单编号：">
                <el-input v-model="orginSplitOrderInfo.id" disabled></el-input>
              </el-form-item>
              <el-form-item label="订单状态">
                <div>
                  {{ orginSplitOrderInfo.orderStatus | orderStatusFilter }}
                </div>
              </el-form-item>
              <el-form-item label="数量">
                <el-input v-model="orginSplitOrderInfo.goodsCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="退货数">
                <el-input v-model="orginSplitOrderInfo.refundCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="销毁数">
                <el-input v-model="orginSplitOrderInfo.destroyCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="FBA/YFF/ZOZO/RSL">
                <el-select v-model="orginSplitOrderInfo.orderType" placeholder="请选择" size="small" disabled>
                  <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库保管">
                <el-select v-model="orginSplitOrderInfo.categoryFlag" placeholder="请选择" size="small" disabled>
                  <el-option key="1" value="1" label="是"></el-option>
                  <el-option key="0" value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
        <el-col :span="12" class="split-col">
          <el-form :model="splitOrderInfo" label-width="120px" class="split-form" :rules="splitFormRules" ref="splitOrderInfo">
            <div class="split-title">拆出订单信息：</div>
            <div>
              <el-form-item label="订单状态">
                <div>{{ splitOrderInfo.orderStatus | orderStatusFilter }}</div>
              </el-form-item>
              <el-form-item label="FBA/YFF/ZOZO/RSL">
                <el-select v-model="splitOrderInfo.orderType" placeholder="请选择" size="small" disabled>
                  <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库保管">
                <el-select v-model="splitOrderInfo.categoryFlag" placeholder="请选择" size="small" disabled>
                  <el-option key="1" value="1" label="是"></el-option>
                  <el-option key="0" value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数量" prop="goodsCount">
                <el-input v-model="splitOrderInfo.goodsCount"></el-input>
              </el-form-item>
              <el-form-item label="退货数" prop="refundCount">
                <el-input v-model="splitOrderInfo.refundCount"></el-input>
              </el-form-item>
              <el-form-item label="销毁数" prop="destroyCount">
                <el-input v-model="splitOrderInfo.destroyCount"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="splitDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="splitSave('splitOrderInfo')">提 交</el-button>
      </span>
    </el-dialog>

    <!--    图片放大-->
    <el-dialog title="" :visible.sync="bigvisible" width="30%" :show-close="false" :close-on-click-modal="false" center>
      <el-upload
        class="editor-slide-upload bigimg"
        action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com"
        :data="imgDataObj"
        :multiple="false"
        ref="uploads"
        :file-list="replyInfo.imgFileList"
        :show-file-list="true"
        list-type="picture-card"
        :on-remove="handleImgRemove2"
        :on-success="handleImgSuccess2"
        accept="image/png,image/jpeg"
        :before-upload="beforeImgUpload"
        :limit="1"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>

      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="imgDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="imgSave('replyInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <!--    购买完-->
    <el-dialog title="" :visible.sync="buyoutvisible" width="40%" show-close :destroy-on-close="true" @close="buyoutDialogClose" center>
      <el-form :model="buyoutInfo" :rules="buyoutrules" ref="buyoutInfo" label-width="120px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item style="margin-bottom: 15px !important" label="用户ID:">
          <span>{{ buyoutInfoonreade.userName }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px !important" label="订单编号:">
          <div style="display: inline-block">
            <span>{{ buyoutInfoonreade.id }}</span>
          </div>
          <div style="display: inline-block; margin-left: 20px" v-if="buyoutInfoonreade.splitOrderId">
            <font color="#0082FF">{{ buyoutInfoonreade.splitOrderId }}-{{ buyoutInfoonreade.splitSeq }}</font>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 20px !important" label="单价:" prop="price">
          <el-input-number
            :disabled="orginSplitOrderInfo.orderStatus != 1"
            v-model="buyoutInfo.price"
            controls-position="right"
            :precision="2"
            :min="0"
            style="width: 350px"
          >
          </el-input-number>
          &emsp;
          <span>历史最低价: {{ buyoutInfoonreade.historyPrice }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 20px !important" label="数量:" prop="goodsCount">
          <el-input-number v-model="buyoutInfo.goodsCount" controls-position="right" :precision="0" :min="0" style="width: 350px"> </el-input-number>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="购买订单号:" prop="buyOrderNumber">
          <el-input
            @blur="optionchange(buyoutInfo.buyOrderNumber, 'ddh', buyoutInfo.orderId)"
            maxlength="50"
            v-model.trim="buyoutInfo.buyOrderNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="购买账号:" prop="buyAccountId">
          <el-select
            v-model.trim="buyoutInfo.buyAccountId"
            @change="optionchange(buyoutInfo.buyAccountId, 'zh', buyoutInfo.orderId)"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 20px !important" label="中国运费:" prop="chineseFreightFee">
          <el-input-number
            v-model="buyoutInfo.chineseFreightFee"
            controls-position="right"
            :precision="2"
            :min="0"
            style="width: 350px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="检品系数:" prop="checkCoefficient">
          <el-input placeholder="0.2~5.0之间" v-model="buyoutInfo.checkCoefficient"></el-input>
        </el-form-item>
        <el-form-item label="中国物流公司:">
          <el-select v-model="buyoutInfo.cnLogisticsCompanyId" @change="updateSelect" placeholder="请选择" size="small" clearable>
            <el-option v-for="item in dropDownList" :key="item.id" :label="item.companyName" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中国运单号:" prop="trackingNumberCn">
          <el-input maxlength="50" v-model="buyoutInfo.trackingNumberCn"></el-input>
        </el-form-item>
        <el-form-item label="免费仓储:" prop="freeWarehousing">
          <el-select v-model="buyoutInfo.freeWarehousing" placeholder="请选择" size="small" clearable>
            <el-option key="1" value="1" label="是"></el-option>
            <el-option key="0" value="0" label="否" selected></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <p style="text-align: center">如果您输入了中国运单号，则订单将直接变为等待到库</p>
        <el-button class="form-btn btn-gray" @click="buyoutDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="buyoutSave('buyoutInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <!--    店铺发货-->
    <el-dialog title="" :visible.sync="Storevisible" width="40%" show-close @close="StoreDialogClose" center>
      <el-form :model="StoreInfo" :rules="Storerules" ref="StoreInfo" label-width="120px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item style="margin-bottom: 15px !important" label="用户ID：">
          <span>{{ buyoutInfoonreade.userName }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px !important" label="订单编号：">
          <div style="display: inline-block">
            <span>{{ buyoutInfoonreade.id }}</span>
          </div>
          <div style="display: inline-block; margin-left: 20px" v-if="buyoutInfoonreade.splitOrderId">
            <font color="#0082FF">{{ buyoutInfoonreade.splitOrderId }}-{{ buyoutInfoonreade.splitSeq }}</font>
          </div>
        </el-form-item>
        <!-- 内容 -->
        <!-- <el-form-item label="国内运费(元)：">
          <el-input v-model="StoreInfo.inlandFreight"></el-input>
        </el-form-item> -->
        <el-form-item label="物流公司:" prop="cnLogisticsCompanyId">
          <el-select v-model="StoreInfo.cnLogisticsCompanyId" placeholder="请选择" size="small" clearable>
            <el-option v-for="item in dropDownList" :key="item.id" :label="item.companyName" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国内运单号:" prop="trackingNumberCn">
          <el-input maxlength="50" v-model="StoreInfo.trackingNumberCn"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="StoreDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="StoreSave('StoreInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <!--  退货  -->
    <el-dialog title="退货" :visible.sync="returnedvisible" width="40%" show-close @close="ReturnedDialogClose" center>
      <el-form :model="returnedInfo" ref="returnedInfo" label-width="120px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item style="margin-bottom: 15px !important" label="用户ID：">
          <span>{{ buyoutInfoonreade.userName }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px !important" label="订单编号：">
          <div style="display: inline-block">
            <span>{{ buyoutInfoonreade.id }}</span>
          </div>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="退货运费(元)：">
          <el-input v-model="returnedInfo.returnFee"></el-input>
        </el-form-item>
        <el-form-item label="退货手续费(元)：">
          <el-input v-model="returnedInfo.refundServiceFee"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="ReturnedDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="ReturnedSave('returnedInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>
    <MessageTip :visiable.sync="isVisiable" :info="replyMessageInfo" @confirm="onConfirmMsg"></MessageTip>
    <el-dialog title="批量购买账号" :visible.sync="accountDialogVisible" width="50%">
      <p class="dialog-account">
        <el-radio v-for="item in buyAcountList" :key="item.id" v-model="batchAccount.buyAccountId" :label="item.id"
          >{{ item.id }}{{ item.platformType_hanzi }}</el-radio
        >
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button @click="accountDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateAccount()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="arrivalRemindDialogVisible" :close-on-click-modal="false" width="50%">
      <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="100px" class="messageTip">
        <!-- 只读 -->
        <div class="lx-flex-row">
          <el-form-item label="订单编号:">
            <span>{{ arrivalRemindInfo.orderId }}</span>
          </el-form-item>
        </div>
        <el-form-item label="内容:" prop="remindingContent">
          <quill-editor ref="text" v-model="arrivalRemindInfo.arrivalRemindContent" :options="editorOption" />
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="arrivalRemindDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="submitArrivalRemind">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="pdfViewDialogVisible" :close-on-click-modal="false" width="100%">
      <iframe id="pdfIframe" @load="adjustIframe" :src="pdfurl" type="application/x-google-chrome-pdf"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { columns as ordersGroup } from "./ordersGroup";
import { filterList } from "@/assets/js/utils";
import LxSort from "@/components/LxSort/index";
import Oss from "../../assets/js/oss.js";
import tableCon from "../../views/tableContainer";
import MessageTip from "@/components/MessageTip/index";
import { CreatedUrl } from "@/class/index";
export default {
  components: {
    LxSort,
    tableCon,
    MessageTip,
  },
  name: "ordersgroup",
  // name: "order/Orders",
  data() {
    //自定义校验产品数量
    const checkGoodsCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) <= 0 || parseInt(value) >= parseInt(this.orginSplitOrderInfo.goodsCount)) {
          callback(new Error("数量应大于0小于原数量"));
        }
        callback();
      } else {
        callback(new Error("请输入数量"));
      }
    };
    const checkRefundCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) < 0 || parseInt(value) > parseInt(this.orginSplitOrderInfo.refundCount)) {
          callback(new Error("退货数应大于等于0小于等于原退货数"));
        }
        callback();
      } else {
        callback(new Error("请输入退货数"));
      }
    };
    const checkDestroyCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (parseInt(value) < 0 || parseInt(value) > parseInt(this.orginSplitOrderInfo.destroyCount)) {
          callback(new Error("销毁数应大于等于0小于等于原销毁数"));
        }
        callback();
      } else {
        callback(new Error("请输入销毁数"));
      }
    };
    return {
      title: "",
      arrivalRemindInfo: {
        orderId: "",
        arrivalRemindContent: "",
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
            ],
          },
        },
      },
      arrivalRemindDialogVisible: false,
      isActive: true,
      batchAccount: {
        buyAccountId: "",
        row: null,
      },
      accountDialogVisible: false,
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      isVisibleSort: false,
      ordersGroup, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      menuSettingData: {
        menuId: "staffOrders",
      },
      accountorderlist: [],
      buyoutInfoonreade: {
        userName: "",
        orderno: "",
        price: "",
        num: "",
        id: "",
        splitOrderId: "",
        splitSeq: "",
      },
      expandedRowKeys: [],
      fileList: [],
      bigvisibleimgDataObj: [],
      bigimgFileList: {},
      bigvisible: false,
      buyoutvisible: false,
      Storevisible: false,
      visible: false,
      returnedvisible: false,
      imgurl: "",
      dropDownList: [],
      queryInfo: {
        id: "",
        trackingNumberCn: "",
        trackingNumberJpn: "",
        sagawaState: "",
        orderStatus: "",
        customerName: "",
        userName: "",
        taobaoUrl: "",
        goodsName: "",
        receiver: "",
        categoryFlag: "",
        createTimeStart: "",
        createTimeEnd: "",
        sendTimeStart: "",
        sendTimeEnd: "",
        orderType: "",
        payMethod: "",
        goodsCode: "",
        pageSize: 10,
        pageNum: 1,
      },
      // orderDateRangeValue:'',
      // shipDateRangeValue:[],
      sagawaStateOptions: [
        {
          value: "1",
          label: "黄金糕",
        },
        {
          value: "2",
          label: "双皮奶",
        },
        {
          value: "3",
          label: "蚵仔煎",
        },
        {
          value: "4",
          label: "龙须面",
        },
        {
          value: "5",
          label: "北京烤鸭",
        },
      ],
      orderStatusOptions: [],
      index: "",
      splitDialogVisible: false,
      orginSplitOrderInfo: {},
      splitOrderInfo: {},
      splitForm: {},
      total: 0,
      splitFormRules: {
        goodsCount: [{ required: true, message: "请输入数量", trigger: "change" }, { validator: checkGoodsCount }],
        refundCount: [{ required: true, message: "请输入退货数", trigger: "change" }, { validator: checkRefundCount }],
        destroyCount: [{ required: true, message: "请输入销毁数", trigger: "change" }, { validator: checkDestroyCount }],
      },
      listObj: [],
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },

      buyoutInfo: {
        orderId: "",
        buyAccountId: "",
        cnLogisticsCompanyId: "",
        buyOrderNumber: "",
        chineseFreightFee: "",
        trackingNumberJpn: "",
        trackingNumberCn: "",
        checkCoefficient: "",
        price: "",
        goodsCount: "",
        freeWarehousing: "0",
      },
      orderlist: [],
      orderList: [],
      orderCount: {
        total: 0,
        pendingPurchaseCount: 0,
        purchasedCount: 0,
        waitWarehouseCount: 0,
        arrivalCount: 0,
        warehouseStorageCount: 0,
        waitPayCount: 0,
        badOrderCount: 0,
        finishCount: 0,
        beConfirmedPurchaseCount: 0,
      },
      fbaOption: [
        {
          label: "否",
          value: "1",
        },
        {
          label: "FBA",
          value: "0",
        },
        {
          label: "YFF",
          value: "2",
        },
        {
          label: "ZOZO",
          value: "3",
        },
        {
          label: "RSL",
          value: "4",
        },
      ],
      StoreInfo: {
        orderId: "",
        inlandFreight: "",
        cnLogisticsCompanyId: "",
        trackingNumberJpn: "",
        trackingNumberCn: "",
      },
      returnedInfo: {
        orderId: "",
        refundServiceFee: 5.0,
        returnFee: 0.0,
      },
      rules: {
        remindingTitle: [{ required: true, message: "请输入标题", trigger: "blur" }],
        remindingContent: [{ required: true, message: "请输入回复内容", trigger: "blur" }],
      },
      buyoutrules: {
        // buyOrderNumber: [
        //   { required: false, validator: validateOeder, trigger: "blur" },
        //   // { pattern: /^[A-Za-z0-9]+$/, message: '只能字母或数字的组合', trigger: 'blur' },
        // ],
        chineseFreightFee: [{ required: true, message: "请输入中国运费", trigger: "blur" }],
        price: [{ required: true, message: "请输入单价", trigger: "blur" }],
        goodsCount: [{ required: true, message: "请输入数量", trigger: "blur" }],
        buyOrderNumber: [{ required: true, message: "请输入购买订单号", trigger: "blur" }],
        buyAccountId: [{ required: true, message: "请输入购买账号", trigger: "change" }],
        /*       checkCoefficient: [
          {
            required: true,
            validator: validateCheckCoefficient,
            trigger: "blur",
          },
        ],*/
      },
      Storerules: {
        // configLogisticsCompanyId: [
        //   { required: true, message: '请选择物流公司', trigger: 'blur' }
        // ],
        trackingNumberCn: [
          { required: true, message: "请输入国内运单号", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "只能字母或数字的组合",
            trigger: "blur",
          },
        ],
      },
      replyMessageInfo: {},
      file: "",
      bigimglist: {
        orderId: "",
        pictureUrl: "",
        upfile: "",
      },
      buyAcountList: [],
      orderDetailList: [],
      isVisiable: false, // 消息提醒弹框
      replyInfo: {
        orderId: "",
        remindingUserName: "",
        remindingTitle: "",
        remindingTitleJa: "",
        remindingContent: "",
        url: "",
        replyPicture: "",
        imgFileList: [],
        imgFileListStr: "",
      },
      ids: [],
      pdfurl: "",
      pdfViewDialogVisible: false,
      scrollListener: null,
      scrollTopCache: 0,
    };
  },
  created() {
    this.getBuyAccountList();
    this.getAsyncColumns().then(() => {
      this.getOrderList();
      this.getAllList();
    });
  },
  activated() {
    this.restoreScroll();
    // 从编辑页返回，刷新页面
    const route = this.$route;
    if (route.query?.show) {
      this.getOrderList();
    }
  },
  mounted() {
    this.restoreScroll();
  },
  methods: {
    restoreScroll() {
      const bodyWrapper = this.$refs.multipleTable.$el.querySelector(".el-table__body-wrapper");
      this.scrollListener = () => {
        this.scrollTopCache = bodyWrapper.scrollTop;
      };
      bodyWrapper.addEventListener("scroll", this.scrollListener);
      // 如果有缓存滚动位置，恢复
      if (this.scrollTopCache) {
        setTimeout(() => {
          bodyWrapper.scrollTop = this.scrollTopCache;
        }, 100);
      }
    },
    // iframe高度
    adjustIframe() {
      var ifm = document.getElementById("pdfIframe");
      ifm.height = document.documentElement.clientHeight - 50;
      ifm.width = document.documentElement.clientWidth - 50;
    },
    handleOrder(row, type) {
      this.$modalDialog(() => import("./components/orders.vue"), {
        row,
        xdType: type,
      }).then(
        () => {
          this.searchList();
        },
        () => {}
      );
    },
    handleOrderTb(row) {
      this.$modalDialog(() => import("./components/ordersTb.vue"), {
        row,
      }).then(
        () => {
          this.searchList();
        },
        () => {}
      );
    },
    // 检品报告-查看
    checkReportView(url) {
      // CreatedUrl.openUrl(url)
      this.pdfViewDialogVisible = true;
      this.pdfurl = url;
    },
    //检品报告-下载
    checkReportDownload(url) {
      CreatedUrl.urlDown(url, "检品报告书.pdf");
    },
    getAuthFreeStorageFee() {
      return window.sessionStorage.getItem("categoryPriceAUTH") == "true";
    },
    //免仓储费
    async freeStorageFee(row) {
      this.$confirm("确定免仓储费吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$http.post("order/exemptionFromStorageFee", row).then(async ({ data }) => {
            if (data.code === 200) {
              this.$message({
                type: "success",
                message: "免仓储费成功!",
              });
              await this.getOrderList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    submitArrivalRemind() {
      // 提交数据
      this.$http.post("order/arrivalRemind", this.arrivalRemindInfo).then(({ data }) => {
        if (data.code === 200) {
          this.arrivalRemindDialogVisible = false;
          this.getOrderList();
          this.$message.success("提交成功");
        }
      });
    },
    arrivalRemind(row) {
      this.arrivalRemindInfo.orderId = row.id;
      this.arrivalRemindInfo.arrivalRemindContent = row.arrivalRemindContent;
      this.arrivalRemindDialogVisible = true;
    },
    getPrice(price, goodsCount) {
      if (!price || !goodsCount) {
        return 0;
      }
      price = Number(price);
      goodsCount = Number(goodsCount);
      return (price * goodsCount).toFixed(2);
    },
    /**
     * 批量更改账号
     */
    batchUpdateAccount() {
      // 没有选择账号给出错误提示
      if (!this.batchAccount.buyAccountId) {
        this.$message({ type: "warning", message: "请选择账号" });
        return false;
      }
      // 隐藏弹窗
      this.accountDialogVisible = false;
      if (this.orderDetailList.length == 0) {
        this.batchAccount.idList = [];
        this.batchAccount.row.orderLists.forEach((item) => {
          this.batchAccount.idList.push(item.id);
        });
      } else {
        // 遍历获取订单id数组
        this.batchAccount.idList = this.orderDetailList.map((item) => item.id);
      }
      // 提交数据
      this.$http.post("order/batchUpdateBuyAccountId", this.batchAccount).then(({ data }) => {
        if (data.code === 200) {
          this.getnewList(this.batchAccount.row.id);
          this.$message.success("提交成功");
        }
      });
    },
    downloadPdf(name, url) {
      let formdata = new FormData();
      formdata.append("FileUrl", url);
      formdata.append("FileName", name);
      this.$http({
        url: "aliyun/oss/download",
        method: "post",
        data: formdata,
        responseType: "blob", //关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "" }); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", name); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview() {
      return;
    },
    // 文件列表移除文件时的钩子
    handleRemove() {
      return;
    },
    // 删除文件之前的钩子
    beforeRemove() {
      return;
    },
    // 文件上传成功时的钩子
    handleSuccess() {
      return;
    },

    // 文件超出个数限制时的钩子
    handleExceed() {
      return;
    },
    // 覆盖默认的上传行为
    async excelUploadRequest(file) {
      let formdata = new FormData();
      formdata.append("file", file.file);
      const { data: res } = await this.$http.post("order/orderBatchUpdate", formdata);
      if (res.code === 200) {
        this.$message.success(`上传成功`);
      }
    },
    //订单批量更新
    async orderExcelUpload(file) {
      let _self = this;

      const isEXCEL = file.file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isEXCEL) {
        _self.$message.error("上传文件只能是 Excel 格式!");
        return;
      }
      let formdata = new FormData();
      formdata.append("file", file.file);
      // formdata.append('modular', 'FBAContainer')
      if (isEXCEL) {
        formdata.append("type", "EXCEL");
      }
      _self.$http.post("order/orderBatchUpdate", formdata).then((res) => {
        if (res.data.code == 200) {
          _self.$message.success("上传成功");
        }
      });
    },
    handleCloseMark(id) {
      this.$http.post("order/closeEditFlag/" + id).then((res) => {
        if (res.data.code === 200) {
          this.getOrderList();
        }
      });
    },
    // 获取已选择列
    getAsyncColumns() {
      return new Promise((resolve) => {
        // 接口start
        this.$http
          .get("menu/menuSetting", {
            params: {
              menuId: "staffOrders",
            },
          })
          .then((res) => {
            var result = [];
            if (res.data.code === 200) {
              var record = res.data.data;
              this.menuSettingData = record;
              result = JSON.parse(record.menuSetting);
            }
            if (result && result.length > 0) {
              result.forEach((item) => {
                this.$set(item, "isShow", true);
              });
              let noSelectList = filterList(this.ordersGroup, result, "columnId");
              this.columns = result.concat(noSelectList);
              this.asyncColumns = result;
              resolve();
            } else {
              this.columns = this.ordersGroup;
              this.columns.forEach((item) => {
                this.$set(item, "isShow", true);
              });
              this.asyncColumns = this.columns;
              resolve();
            }
          });
      });
    },
    // 保存选择的列
    doSaveColumns(list) {
      var my = this;
      // 接口
      let url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then((res) => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: "保存成功",
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getOrderList();
          });
        } else {
          my.$message({
            type: "warning",
            message: "保存失败",
          });
        }
      });
    },
    // 排序
    toSort() {
      this.isVisibleSort = true;
    },
    async optionchange(value, type, id) {
      if (!this.buyoutInfo.buyOrderNumber && type === "ddh") {
        this.$message.error("请输入购买订单号");
        throw error("请输入购买订单号");
      }
      if (!this.buyoutInfo.buyAccountId && type === "zh") {
        this.$message.error("请输入购买账号");
        throw error("请输入购买账号");
      }
      if (type === "ddh") {
        const { data: res } = await this.$http.post("/order/updateNotes", {
          orderId: id,
          buyOrderNumber: value,
        });
      } else {
        const { data: res } = await this.$http.post("/order/updateNotes", {
          orderId: id,
          buyAccountId: value,
        });
      }
    },
    // 编辑实际价格和历史价格
    async handelPrice(row) {
      let params = {
        orderId: row.id,
        actualPrice: row.actualPrice,
      };
      const { data: res } = await this.$http.post("/order/updateActualPrice", params);
      if (res.code == 200) {
        this.$message.success("操作成功！");
        this.getOrderList();
      }
    },
    // 父级
    async quickSaveAll(value, type, rowData) {
      const id = rowData.id;
      if (this.ids.length == 0) {
        rowData.orderLists.forEach((item) => {
          if (item.orderStatus != 89 && item.orderStatus != 56) {
            this.ids.push(item.id);
          }
        });
      }
      if (type === "0") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderIdList: this.ids,
          orderId: id,
          productDesc: value,
          quickSaveType: type,
        });
      } else if (type === "7") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderIdList: this.ids,
          orderId: id,
          productDescEn: value,
          quickSaveType: type,
        });
      } else if (type === "4") {
        this.batchAccount.buyAccountId = value;
        if (this.orderDetailList.length == 0) {
          this.batchAccount.idList = [];
          rowData.orderLists.forEach((item) => {
            if (item.orderStatus != 89 && item.orderStatus != 56) {
              this.batchAccount.idList.push(item.id);
            }
          });
        } else {
          // 遍历获取订单id数组
          this.batchAccount.idList = this.orderDetailList.map((item) => item.id);
        }
        // 提交数据
        this.$http.post("order/batchUpdateBuyAccountId", this.batchAccount).then(({ data }) => {
          if (data.code === 200) {
            this.getnewList(id);
            this.$message.success("提交成功");
          }
        });
      } else if (type === "3") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderIdList: this.ids,
          orderId: id,
          buyOrderNumber: value,
          quickSaveType: type,
        });
      } else if (type === "5") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderIdList: this.ids,
          orderId: id,
          staffRemark: value,
          quickSaveType: type,
        });
      } else if (type === "6") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderIdList: this.ids,
          orderId: id,
          checkRemark: value,
          quickSaveType: type,
        });
      }
      this.getnewList(id);
    },
    //快速保存
    async quickSave(value, type, rowData, flag = false) {
      const id = rowData.id;
      if (flag) {
        console.log(flag);
        const params = {
          orderId: id,
          buyOrderNumber: value,
        };
        const res = await this.$http.get("/order/updateOrderData", { params });
        console.log(res);
        // this.getOrderList()
      } else if (type === "0") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderIdList: this.ids,
          orderId: id,
          productDesc: value,
          quickSaveType: type,
        });
        this.getnewList(id);
      } else if (type === "1") {
        if (!value && value !== 0) {
          this.$message.error("中国运费不能设置为空");
        } else if (
          (value.split("")[0] == 0 && value.split("")[1] == 0) ||
          (value.split("")[0] == 0 && value.split("").length > 1 && value.split("")[1] !== ".")
        ) {
          this.$message.error("请正确输入运费！");
        } else {
          const { data: res } = await this.$http.post("/order/quickSave", {
            orderId: id,
            chineseFreightFee: value,
            quickSaveType: type,
          });
          if (res.code == 200) {
            // 保存当前选中的子订单ID
            const selectedIds = this.multipleSelection ? [...this.multipleSelection.map((item) => item.id)] : [];
            const { data: res } = await this.$http.get("groupOrder/listByStaff", {
              params: this.queryInfo,
            });
            this.orderList.forEach((item, index) => {
              if (item.groupId == rowData.groupId) {
                this.orderList[index].groupAgentServiceFee = res.data.list[index].groupAgentServiceFee;
                this.orderList[index].groupChineseFreightFee = res.data.list[index].groupChineseFreightFee;
              }
            });
            // 恢复选中状态
            this.$nextTick(() => {
              if (selectedIds.length > 0) {
                this.orderList.forEach((parentOrder) => {
                  if (this.expandedRowKeys.includes(parentOrder.id) && parentOrder.orderLists && parentOrder.orderLists.length > 0) {
                    const childTableRef = this.$refs["childTable" + parentOrder.id];
                    if (childTableRef) {
                      parentOrder.orderLists.forEach((childOrder) => {
                        if (selectedIds.includes(childOrder.id)) {
                          childTableRef.toggleRowSelection(childOrder, true);
                        }
                      });
                    }
                  }
                });
              }
            });
          }
          if (!!res.data) {
            rowData.agentServiceFee = res.data.agentServiceFee;
          }
        }
      } else if (type === "2") {
        if (value && Number(value) > 0) {
          const { data: res } = await this.$http.post("/order/quickSave", {
            orderId: id,
            price: value,
            quickSaveType: type,
          });
        } else {
          this.$message.error("单价不能设置为空");
        }
      } else if (type === "3") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          buyOrderNumber: value,
          quickSaveType: type,
        });
      } else if (type === "4") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          buyAccountId: value,
          quickSaveType: type,
        });
      } else if (type === "5") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          staffRemark: value,
          quickSaveType: type,
        });
      } else if (type === "6") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          checkRemark: value,
          quickSaveType: type,
        });
      } else if (type === "7") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderIdList: this.ids,
          orderId: id,
          productDescEn: value,
          quickSaveType: type,
        });
        this.getnewList(id);
      } else if (type === "9") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          checkCoefficient: value,
          quickSaveType: type,
        });
      } else if (type === "10") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          agentServiceFee: value,
          quickSaveType: type,
        });
      }
    },
    async trackingNumberChangeAll(value, row) {
      if (this.ids.length == 0) {
        row.orderLists.forEach((item) => {
          if (item.orderStatus != 89 && item.orderStatus != 56) {
            this.ids.push(item.id);
          }
        });
      }
      this.$http
        .post("/order/orderListUpdateTrackNumberCn", {
          orderIdList: this.ids,
          orderId: row.id,
          trackingNumberCn: value,
        })
        .then((res) => {
          if (res.data.code == "200") {
            this.getnewList(row.id);
          }
        });
    },
    async trackingNumberChange(value, id) {
      this.$http
        .post("/order/orderListUpdateTrackNumberCn", {
          orderId: id,
          trackingNumberCn: value,
        })
        .then((res) => {
          if (res.data.code == "200") {
            // this.getOrderList();
          }
        });
    },
    async getAllList() {
      const { data: res } = await this.$http.get("/cms/configAccountNumber/getAllList");
      this.accountorderlist = res.data;
    },
    onPasteUpload(event) {
      event.stopPropagation();
      let text = event.clipboardData || window.clipboardData;
      this.bigimglist.upfile = text.files[0];
      this.bigimglist.pictureUrl = "";
      if (text.files[0] === null) {
        this.$message.error("仅支持图片文件");
      } else {
        // 将文件流转换为img认识的格式放在页面
        let blob = new Blob([text.files[0]]); // 返回的文件流数据
        let url = window.URL.createObjectURL(blob); // 将他转化为路径
        this.replyInfo.imgFileList = [{ url }];
        var su = document.getElementsByClassName("el-upload--picture-card")[0];
        this.$nextTick(() => {
          su.style.display = "none";
        });
      }
    },
    async getDropDownList() {
      const { data: res } = await this.$http.post("cms/logisticsCompany/getDropDownList");
      this.dropDownList = res.data;
    },

    buyout(row) {
      console.log(row);
      this.buyoutvisible = true;
      this.buyoutInfo.price = row.price;
      this.buyoutInfo.goodsCount = row.goodsCount;
      this.buyoutInfoonreade.userName = row.userName;
      this.buyoutInfoonreade.id = row.id;
      this.buyoutInfoonreade.splitOrderId = row.splitOrderId;
      this.buyoutInfoonreade.splitSeq = row.splitSeq;
      this.buyoutInfoonreade.price = row.price;
      this.buyoutInfoonreade.num = row.goodsCount;
      this.buyoutInfoonreade.historyPrice = row.historyPrice;
      this.buyoutInfo.orderId = row.id;
      this.buyoutInfo.chineseFreightFee = row.chineseFreightFee;
      this.buyoutInfo.buyOrderNumber = row.buyOrderNumber;
      this.buyoutInfo.buyAccountId = row.buyAccountId;
      this.buyoutInfo.trackingNumberCn = row.trackingNumberCn;
      this.buyoutInfo.cnLogisticsCompanyId = row.cnLogisticsCompanyId;
      if (!row.trackingNumberCn) {
        row.trackingNumberCn = null;
      }
      this.$set(this.buyoutInfo, "checkCoefficient", row.checkCoefficient || 1);
      this.$set(this.buyoutInfo, "trackingNumberCn", row.trackingNumberCn);
      this.$http.get("cms/configAccountNumber/getAllList").then((res) => {
        this.orderlist = res.data.data;
      });
      this.getDropDownList();
    },
    cantBuy(row) {
      this.$confirm("确认后不可更改，是否确认该商品切换成无库存状态？", "无库存", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.post(`order/updateCantBuy/` + row.id);
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: "无法购买成功!",
            });
            await this.getOrderList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消无法购买",
          });
        });
    },
    cantBuyAll(row) {
      this.$confirm("确认后不可更改，是否确认该商品切换成无库存状态？", "无库存", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          if (this.ids.length == 0) {
            this.$message({
              type: "warning",
              message: "请先选择订单",
            });
            return;
          }
          const { data: res } = await this.$http.post(`groupOrder/updateCantBuy`, [...this.ids]);
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: "无法购买成功!",
            });
            await this.getOrderList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消无法购买",
          });
        });
    },
    returned(row) {
      this.$confirm("确认后不可更改，是否确认该商品退货并退还客户已扣除的费用？", "退货", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.post(`order/updateReturned/` + row.id);
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: "退货成功!",
            });
            await this.getOrderList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退货",
          });
        });
    },
    getBuyAccountList() {
      this.$http.get("cms/configAccountNumber/getAllList").then((res) => {
        this.buyAcountList = res.data.data;
        this.buyAcountList.map((res) => {
          if (res.platformType !== null) {
            switch (res.platformType) {
              case "0":
                return (res.platformType_hanzi = "淘宝 -" + res.accountNumber);
                break;
              case "1":
                return (res.platformType_hanzi = "1688 -" + res.accountNumber);
                break;
              case "2":
                return (res.platformType_hanzi = "京东 -" + res.accountNumber);
                break;
              case "3":
                return (res.platformType_hanzi = "拼多多 -" + res.accountNumber);
                break;
              case null:
                return (res.platformType_hanzi = "");
                break;
            }
          }
        });
      });
    },
    async Store(row) {
      this.Storevisible = true;
      this.getDropDownList();
      // this.buyoutvisible=true
      this.buyoutInfoonreade.userName = row.userName;
      this.buyoutInfoonreade.id = row.id;
      this.buyoutInfoonreade.splitOrderId = row.splitOrderId;
      this.buyoutInfoonreade.splitSeq = row.splitSeq;
      this.buyoutInfoonreade.price = row.price;
      this.buyoutInfoonreade.num = row.goodsCount;
      this.StoreInfo.orderId = row.id;

      const { data: res } = await this.$http.get("order/" + row.id);
      this.StoreInfo.inlandFreight = res.data.inlandFreight;
      // this.StoreInfo.cnLogisticsCompanyId = res.data.cnLogisticsCompanyId;
      this.$set(this.StoreInfo, "cnLogisticsCompanyId", res.data.cnLogisticsCompanyId);
      this.$set(this.StoreInfo, "trackingNumberCn", res.data.trackingNumberCn);
    },
    async Returned(row) {
      this.returnedvisible = true;
      this.buyoutInfoonreade.userName = row.userName;
      this.buyoutInfoonreade.id = row.id;
      this.returnedInfo.orderId = row.id;
    },
    handleImgRemove2(file) {
      Oss.imgRemove(file, this.listObj);
      var su = document.getElementsByClassName("el-upload--picture-card")[0];
      this.$nextTick(() => {
        su.style.display = "block";
      });
      this.bigimglist.upfile = "";
      this.bigimglist.pictureUrl = "";
    },
    imgclick(url, index) {
      this.index = index;
      this.bigvisible = true;
      if (url.pictureUrl == "" || url.pictureUrl == undefined) {
        this.$nextTick(() => {
          var su = document.getElementsByClassName("el-upload--picture-card")[0];
          su.style.display = "block";
          this.replyInfo.imgFileList = [];
        });
      } else {
        this.$nextTick(() => {
          var su = document.getElementsByClassName("el-upload--picture-card")[0];
          su.style.display = "none";
          this.replyInfo.imgFileList = [
            {
              url: url.pictureUrl,
            },
          ];
        });
      }
      this.bigimglist.orderId = url.id;
      var su = document.getElementsByClassName("el-upload-list__item")[0];
      document.addEventListener("paste", this.onPasteUpload);
    },
    imgDialogClose() {
      this.bigvisible = false;
      if (this.replyInfo.imgFileList.length === 0) {
        var su = document.getElementsByClassName("el-upload--picture-card")[0];
        this.$nextTick(() => {
          su.style.display = "block";
        });
      } else {
        var su = document.getElementsByClassName("el-upload--picture-card")[0];
        this.$nextTick(() => {
          su.style.display = "none";
        });
      }
    },
    async uploadFile() {
      var formdata = new FormData();
      formdata.append("orderId", this.bigimglist.orderId);
      var su = this.orderList[this.index].pictureUrl;
      this.bigimglist.pictureUrl === undefined ? formdata.append("pictureUrl", su) : formdata.append("pictureUrl", this.bigimglist.pictureUrl);

      formdata.append("upfile", this.bigimglist.upfile);
      const { data: res } = await this.$http.post("order/uploadFile", formdata);
      if (res.code === 200) {
        this.$message.success("上传成功");
        this.bigvisible = false;

        this.getOrderList();
      } else {
        this.$message.error(res.message);
      }
    },
    imgSave() {
      this.handleImgSubmit();

      if (this.replyInfo.replyPicture.indexOf(",")) {
        this.replyInfo.replyPicture = this.replyInfo.replyPicture.split(",")[1];
      }

      if (this.bigimglist.upfile === "") {
        this.bigimglist.pictureUrl = this.replyInfo.replyPicture;
      } else {
        this.bigimglist.pictureUrl = "";
      }
      this.replyInfo.imgFileList = this.replyInfo.imgFileList.splice(1, 1);
      this.uploadFile();
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    orderDateRange() {},
    shipDateRange() {},
    //拆单按钮显示
    showSplitOrderBtn(row) {
      if (
        // row.orderStatus == 0 ||
        row.orderStatus == 1 ||
        // row.orderStatus == 2 ||
        row.orderStatus == 4 ||
        row.orderStatus == 8 ||
        row.orderStatus == 12 ||
        row.orderStatus == 16
      ) {
        if (row.goodsCount > 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }, //编辑按钮显示
    showEditBtn(status) {
      if (
        status == 0 ||
        status == 1 ||
        status == 2 ||
        status == 4 ||
        status == 8 ||
        status == 16 ||
        status == 24 ||
        status == 26 ||
        status == 28 ||
        status == 32 ||
        status == 36 ||
        status == 82 ||
        status == 40 ||
        status == 60 ||
        status == 76
      ) {
        return true;
      } else {
        return false;
      }
    },
    //账单按钮显示   已销毁84 已退货72 已发送52 待退货68 装箱中88 待发送48 销毁待支付80 待支付44 退货待支付64
    // showBill (status) {
    //   if (status == 84 || status == 72 || status == 52 || status == 68 || status == 88 || status == 48 || status == 80 || status == 44 || status == 64) {
    //     return true;
    //   }
    //   else {
    //     return false;
    //   }
    // },
    //发送账单按钮显示  检品完12 申请发货20 退货申请中60 销毁申请中76
    // showSendBill (status) {
    //   if (status == 12 || status == 20 || status == 60 || status == 76) {
    //     return true;
    //   }
    //   else {
    //     return false;
    //   }
    // },
    // addBill (e) {
    //   this.$router.push({
    //     path: 'orders/bill',
    //     query: {
    //       id: e.id,
    //       isAdd: '0',
    //       //orderNumber:e.orderNumber,
    //     }
    //   })
    // },
    // addSendBill (e) {
    //   this.$router.push({
    //     path: 'orders/bill',
    //     query: {
    //       id: e.id,
    //       isAdd: '1',
    //       //orderNumber:e.orderNumber,
    //     }
    //   })
    // },
    queryInfoClear() {
      (this.curIndex = 0), (this.queryInfo.orderStatus = "");
      (this.queryInfo.buyAccountId = ""),
        (this.queryInfo.userName = ""),
        (this.queryInfo.id = ""),
        (this.queryInfo.trackingNumberCn = ""),
        (this.queryInfo.trackingNumberJpn = ""),
        (this.queryInfo.sagawaState = ""),
        (this.queryInfo.taobaoUrl = ""),
        // orderStatus: '',
        // orderStatusList:[],
        (this.queryInfo.customerName = ""),
        (this.queryInfo.goodsName = ""),
        (this.queryInfo.buyOrderNumber = ""),
        (this.queryInfo.receiver = ""),
        (this.queryInfo.categoryFlag = ""),
        (this.queryInfo.createTimeStart = ""),
        (this.queryInfo.createTimeEnd = ""),
        (this.queryInfo.sendTimeStart = ""),
        (this.queryInfo.sendTimeEnd = ""),
        (this.queryInfo.orderType = ""),
        (this.queryInfo.payMethod = ""),
        (this.queryInfo.goodsCode = ""),
        (this.queryInfo.pageSize = 10),
        (this.queryInfo.pageNum = 1);
      // this.orderDateRangeValue = '';
      // this.shipDateRangeValue = [];
    },
    searchList(status, index) {
      if (index || index == 0) {
        this.curIndex = index;
      }
      if (status == -1) {
        //全部
        this.queryInfo.orderStatus = "";
      } else if (status == 11) {
        //待确认
        this.queryInfo.orderStatus = "99";
      } else if (status == 1) {
        //待购买
        this.queryInfo.orderStatus = "1";
      } else if (status == 2) {
        //购买完
        this.queryInfo.orderStatus = "2";
      } else if (status == 0) {
        //等待到库
        this.queryInfo.orderStatus = "0";
      } else if (status == 4) {
        //已到货（到库，检品中，检品完，申请发货，装箱中，待发送）
        // this.queryInfo.orderStatus = '4,8,12,20,48,88';
        //已到货（到库，检品中，装箱中，待发送）
        this.queryInfo.orderStatus = "4,8,48,88";
      } else if (status == 5) {
        //仓库保管中
        this.queryInfo.orderStatus = "16";
      } else if (status == 6) {
        //待支付、退货待支付、销毁待支付
        this.queryInfo.orderStatus = "44,64,80";
      } else if (status == 7) {
        //不良订单（不良待处理，换货待发回，换货待到货，待部分退货，退货待支付，退货申请中，待退货，补发等待到货，销毁申请中，销毁待支付，待部分销毁，不良驳回）
        // this.queryInfo.orderStatus = '24,28,32,36,68,64,40,76,80,82,26,60';
        //不良订单（不良待处理，换货待发回，换货待到货，待部分退货，待退货，补发等待到货，待部分销毁，不良驳回）
        this.queryInfo.orderStatus = "24,28,32,36,68,40,82,26";
      } else if (status == 8) {
        //已完成（已发送，已取消，已退货，已销毁）
        this.queryInfo.orderStatus = "52,56,72,84";
      } else if (status == 9) {
        //代发账单(检品完、申请发货、退货申请中、销毁申请中)
        this.queryInfo.orderStatus = "12,20,60,76";
      } else if (status == 10) {
        //无法购买(无法购买)
        this.queryInfo.orderStatus = "89";
      }
      this.queryInfo.pageNum = 1;
      this.getOrderList();
    },
    categoryFlagChanged(row) {
      //改变状态接口 params row.No,row.categoryFlag
      setTimeout(() => {
        row.categoryFlag = !row.categoryFlag;
        alert("failed");
      }, 1000);
    },
    async getOrderList() {
      this.isLoading = true;
      // 保存当前选中的子订单ID
      const selectedIds = this.multipleSelection ? [...this.multipleSelection.map((item) => item.id)] : [];

      const { data: res } = await this.$http.get("groupOrder/listByStaff", {
        params: this.queryInfo,
      });
      res.data.list.map((res) => {
        var flag = false;
        this.buyAcountList.map((item) => {
          if (item.id === res.buyAccountId && res.buyAccountId !== null) {
            flag = true;
          }
        });
        if (!flag) {
          res.buyAccountId = null;
        }
      });
      this.orderList = res.data.list;
      this.$forceUpdate(); // 确保DOM更新
      this.total = res.data.total;
      this.isLoading = false;

      // 恢复选中状态
      this.$nextTick(() => {
        if (selectedIds.length > 0) {
          this.orderList.forEach((parentOrder) => {
            if (this.expandedRowKeys.includes(parentOrder.id) && parentOrder.orderLists && parentOrder.orderLists.length > 0) {
              const childTableRef = this.$refs["childTable" + parentOrder.id];
              if (childTableRef) {
                parentOrder.orderLists.forEach((childOrder) => {
                  if (selectedIds.includes(childOrder.id)) {
                    childTableRef.toggleRowSelection(childOrder, true);
                  }
                });
              }
            }
          });
        }
      });
    },
    async getnewList(rowid) {
      // 保存当前选中的子订单ID
      const selectedIds = this.multipleSelection ? [...this.multipleSelection.map((item) => item.id)] : [];
      const { data: res } = await this.$http.get("groupOrder/listByStaff", {
        params: this.queryInfo,
      });
      this.orderList.forEach((item, index) => {
        if (item.id === rowid) {
          this.orderList[index].orderLists = res.data.list[index].orderLists;
        }
      });
      // this.orderDetailList = [];
      // this.ids = [];
      // 恢复选中状态
      this.$nextTick(() => {
        if (selectedIds.length > 0) {
          this.orderList.forEach((parentOrder) => {
            if (this.expandedRowKeys.includes(parentOrder.id) && parentOrder.orderLists && parentOrder.orderLists.length > 0) {
              const childTableRef = this.$refs["childTable" + parentOrder.id];
              if (childTableRef) {
                parentOrder.orderLists.forEach((childOrder) => {
                  if (selectedIds.includes(childOrder.id)) {
                    childTableRef.toggleRowSelection(childOrder, true);
                  }
                });
              }
            }
          });
        }
      });
    },
    toOrderDetail(row) {
      this.$router.push({
        name: "orderDetail",
        query: {
          id: row.id,
          customerId: row.customerUserId,
          isEdit: "0",
        },
      });
    },
    toGoodsDetail(row) {
      this.$http.get("/purchase/changeUrlAction", { params: { url: row.taobaoUrl } }).then((res) => {
        const changeUrl = res.data.data;
        console.log(changeUrl);
        window.open(changeUrl, "_blank");
      });
    },
    toEditOrder(row) {
      this.$router.push({
        name: "orderDetail",
        query: {
          id: row.id,
          customerId: row.customerUserId,
          isEdit: "1",
        },
      });
    },
    splitOrder(row) {
      this.splitDialogVisible = true;
      this.orginSplitOrderInfo = row;
      this.splitOrderInfo = JSON.parse(JSON.stringify(row));
    },
    splitDialogClosed() {
      this.splitDialogVisible = false;
    },
    splitSave(formName) {
      this.$refs[formName].validate(async (valid) => {
        let params = {
          id: this.splitOrderInfo.id,
          goodsCount: this.splitOrderInfo.goodsCount,
          refundCount: this.splitOrderInfo.refundCount,
          destroyCount: this.splitOrderInfo.destroyCount,
        };
        if (valid) {
          const { data: res } = await this.$http.post("empArrOrder/spilt", params);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message,
            });
            this.splitDialogClosed();
            await this.getOrderList();
          } else {
            this.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    saveRemark(row) {
      this.savePost(row);
    },
    async savePost(row) {
      const { data: res } = await this.$http.post("order/updateNotes", {
        orderId: row.id,
        staffRemark: row.staffRemark,
      });
      if (res.code == 200) {
        this.getOrderList();
      } else {
        this.$message.error(res.message);

        this.getOrderList();
      }
    },
    async saveProductDesc(row) {
      const { data: res } = await this.$http.post("order/updateNotes", {
        orderId: row.id,
        productDesc: row.productDesc,
      });
      if (res.code == 200) {
        this.getOrderList();
      } else {
        this.$message.error(res.message);

        this.getOrderList();
      }
    },

    async updatePurchaseStatus(parms) {
      const { data: res } = await this.$http.post("order/updatePurchaseStatus", parms);
      if (res.code === 200) {
        this.$message.success("操作成功");
        this.buyoutvisible = false;

        this.getOrderList();
      } else {
        this.$message.error(res.message);
      }
    },
    buyoutSave(formName) {
      //提醒弹窗保存按钮
      // this.buyoutInfo.price = this.buyoutInfoonreade.price
      // this.buyoutInfo.goodsCount = this.buyoutInfoonreade.num

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.optionchange();
          // alert(1);
          // return;
          this.updatePurchaseStatus(this.buyoutInfo);
        }
      });
    },
    buyoutDialogClose() {
      //关闭提醒弹窗
      this.buyoutvisible = false;
      this.$refs.buyoutInfo.resetFields;
      this.buyoutInfo = {
        orderId: "",
        buyAccountId: "",
        configLogisticsCompanyId: "",
        buyOrderNumber: "",
        inlandFreight: "",
        trackingNumberJpn: "",
        trackingNumberCn: "",
      };
    },
    //取消购买完
    async cancelPurchaseStatus(row) {
      this.$confirm("确定取消购买吗？", "取消购买", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          this.buyoutInfo.orderId = row.id;
          const { data: res } = await this.$http.post("order/cancelPurchaseStatus/" + row.id);
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: "取消购买完成功!",
            });
            await this.getOrderList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //取消收货
    async cancelCheckIn(row) {
      this.$confirm("确定取消收货吗？", "取消收货", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          this.buyoutInfo.orderId = row.id;
          const { data: res } = await this.$http.post("order/cancelCheckIn/" + row.id);
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: "取消收货成功!",
            });
            await this.getOrderList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //取消检品
    async cancelCheck(row) {
      this.$confirm("确定取消检品吗？", "取消检品", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          this.buyoutInfo.orderId = row.id;
          const { data: res } = await this.$http.post("order/cancelCheck/" + row.id);
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: "取消检品成功!",
            });
            await this.getOrderList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    async updateSendStatus(parms) {
      const { data: res } = await this.$http.post("order/updateSendStatus", parms);
      if (res.code === 200) {
        this.$message.success("操作成功");
        this.Storevisible = false;

        this.getOrderList();
      } else {
        this.$message.error(res.message);
      }
    },
    StoreSave(formName) {
      //提醒弹窗保存按钮
      // console.log('this.StoreInfo',this.StoreInfo)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.Storevisible = false;

          this.getOrderList();
          this.updateSendStatus(this.StoreInfo);
        }
      });
    },
    StoreDialogClose() {
      //关闭提醒弹窗
      this.Storevisible = false;
      this.$refs.StoreInfo.resetFields;
      this.StoreInfo = {
        orderId: "",
        inlandFreight: "",
        configLogisticsCompanyId: "",
        trackingNumberJpn: "",
        trackingNumberCn: "",
      };
    },
    ReturnedSave(formName) {
      //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateReturned(this.returnedInfo);
        }
      });
    },
    ReturnedDialogClose() {
      //关闭提醒弹窗
      this.returnedvisible = false;
      this.$refs.returnedInfo.resetFields;
      this.returnedInfo = {
        orderId: "",
        refundServiceFee: 5.0,
        returnFee: 0.0,
      };
    },
    async updateReturned(parms) {
      const { data: res } = await this.$http.post("order/updateReturned", parms);
      if (res.code === 200) {
        this.$message.success("操作成功");
        this.returnedvisible = false;

        this.getOrderList();
      } else {
        this.$message.error(res.message);
      }
    },
    remind(row) {
      //提醒
      this.replyMessageInfo = row;
      this.isVisiable = true;
    },
    onConfirmMsg() {
      this.isVisiable = false;

      this.getOrderList();
    },
    clearReplyForm() {
      //弹窗的取消按钮
      this.initReplyForm();
      this.replyDialogVisible = false;
    },
    initReplyForm() {
      //初始化弹窗的内容
      this.replyInfo = {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
      };
    },

    showImgDialog(index) {
      this.imgDialogVisible = true;
    },
    handleImgSubmit() {
      var _this = this;
      let arr = [];
      Object.keys(_this.listObj).map((v) => {
        arr.push(_this.listObj[v]);
      });
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message("请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！");
        return;
      } else {
        if (arr.length > 1) {
          _this.$message.error("最多可上传1张图片");
        } else {
          _this.replyInfo.imgFileList = _this.replyInfo.imgFileList.concat(arr);
          var urlArr = [];
          _this.replyInfo.imgFileList.forEach((el) => {
            urlArr.push(el.url);
          });
          _this.replyInfo.replyPicture = urlArr.toString();
          _this.$emit("successCBK", arr);
          _this.listObj = {};
          _this.imgDialogVisible = false;
        }
      }
    },

    handleImgSuccess2(response, file, fileList) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
      var su = document.getElementsByClassName("el-upload--picture-card")[0];
      this.$nextTick(() => {
        su.style.display = "none";
      });
    },
    beforeImgUpload(file) {
      const _self = this;
      if (file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png") {
        _self.$message.error("请上传jpg,jpeg,png格式的图片！");
        return false;
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/;
      if (specialReg.test(file.name)) {
        _self.$message.error("文件名中不能包含以下字符 ，；：｛｝* 请检查后修改文件名后再上传");
        return false;
      }
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy;
            _self.imgDataObj.signature = response.data.data.signature;
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.imgDataObj.key = response.data.data.dir + "/order/" + num + "${filename}";
            _self.imgDataObj.dir = response.data.data.dir + "/order";
            _self.imgDataObj.host = response.data.data.host;
            _self.imgDataObj.timeStamp = num;
            file.timeStamp = num;
            Oss.imgCompress(file, this.listObj, resolve, reject);
          })
          .catch((err) => {
            reject(true);
          });
      });
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;

      this.getOrderList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;

      this.getOrderList();
    },
    tableSelect(selection) {
      this.tableSelectAll(selection);
    },
    tableSelectAll(selection) {
      this.orderDetailList = [];
      this.ids = [];
      selection.forEach((item) => {
        this.orderDetailList.push(item);
        this.ids.push(item.id);
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleParentRowClick(row, column, event) {
      // 如果点击的是展开图标，则由表格自行处理
      if (event.target.closest('.el-table__expand-icon')) {
        return;
      }

      const clickedElement = event.target;
      console.log('clickedElement.tagName', clickedElement.tagName);
      
      if (clickedElement.tagName === 'BUTTON' || 
          clickedElement.tagName === 'INPUT' || 
          clickedElement.tagName === 'A' ||
          clickedElement.tagName === 'SPAN' ||
          clickedElement.tagName === 'INPUT' ||
          clickedElement.tagName === 'TEXTAREA' ||
          clickedElement.closest('.el-select') ||
          clickedElement.closest('.el-input')
         ) {
        return;
      }

      this.$refs.multipleTable.toggleRowExpansion(row);
    },
    getRowKey(row) {
      return row.id;
    },
    handleExpandChange(row, expandedRows) {
      if (expandedRows.length > 0) {
        this.expandedRowKeys = [row.id];
      } else {
        this.expandedRowKeys = [];
      }
      this.orderDetailList = [];
      this.multipleSelection = [];
      this.ids = [];
    },
    cancelBatchUpdatePurchaseStatus() {
      if (this.orderDetailList.length > 0) {
        this.$confirm("确定批量取消购买吗？", "取消购买", {
          confirmButtonText: "提交",
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: "取消",
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        })
          .then(async () => {
            this.$http.post("order/cancelBatchUpdatePurchaseStatus", this.orderDetailList).then((res) => {
              if (res.data.code === 200) {
                this.$message.success("操作成功");

                this.getOrderList();
              } else {
                this.$message.error(res.data.message);

                this.getOrderList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请先选择订单",
        });
      }
    },
    batchUpdatePurchaseStatus() {
      console.log(this.orderDetailList);

      if (this.orderDetailList.length > 0) {
        const flag = this.orderDetailList.some((it) => {
          return !it.chineseFreightFee || !it.price || !it.buyOrderNumber || !it.buyAccountId;
        });
        if (!flag) {
          this.$http.post("order/batchUpdatePurchaseStatus", this.orderDetailList).then((res) => {
            if (res.data.code === 200) {
              this.$message.success("操作成功");

              this.getOrderList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          this.$message.error("所选数据含有未填写的'中国运费'、'单价'、'购买订单号'、'购买账号'");
        }
      } else {
        this.$message({
          type: "warning",
          message: "请先选择订单",
        });
      }
    },
    // 导出加购
    async exportActionTwo() {
      this.getNowFormatDate();
      if (this.queryInfo.createTimeStart == "" || this.queryInfo.createTimeEnd == "") {
        this.$message({
          type: "warning",
          message: "下单时间段不能为空",
        });
        return;
      }
      let startTime = new Date(this.queryInfo.createTimeStart).getTime();
      let endTime = new Date(this.queryInfo.createTimeEnd).getTime();
      if (startTime > endTime) {
        this.$message({
          type: "warning",
          message: "开始时间不能大于结束时间",
        });
        return;
      }
      if (endTime - startTime > 60 * 60 * 24 * 365 * 1000) {
        this.$message({
          type: "warning",
          message: "间隔不能大于一年",
        });
        return;
      }
      this.$http({
        url: "order/exportShoppingCart",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        params: this.queryInfo,
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          //设置连接
          link.href = URL.createObjectURL(blob);
          link.download = `导出加购${this.currentdate}.xlsx`;
          document.body.appendChild(link);
          //模拟点击事件
          link.click();
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    async exportAction() {
      this.$http({
        url: "order/exportAction",
        method: "get",
        params: this.queryInfo,
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          //设置连接
          link.href = URL.createObjectURL(blob);
          link.download = "订单列表.xlsx";
          document.body.appendChild(link);
          //模拟点击事件
          link.click();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //订单导出
    orderExport() {
      this.getNowFormatDate();
      // var params = qs.stringify({
      //   token: window.sessionStorage.getItem('token'),
      //   id: id
      // })
      // window.location.href = "/api/container/exportInvoice?id=" + id

      // let url = '/api/container/exportInvoice?id=' + id
      // window.location.href = `${url}`

      if (this.queryInfo.createTimeStart == "" || this.queryInfo.createTimeEnd == "") {
        this.$message({
          type: "warning",
          message: "下单时间段不能为空",
        });
        return;
      }

      let startTime = new Date(this.queryInfo.createTimeStart).getTime();
      let endTime = new Date(this.queryInfo.createTimeEnd).getTime();

      if (startTime > endTime) {
        this.$message({
          type: "warning",
          message: "开始时间不能大于结束时间",
        });
        return;
      }

      if (endTime - startTime > 60 * 60 * 24 * 365 * 1000) {
        this.$message({
          type: "warning",
          message: "间隔不能大于一年",
        });
        return;
      }

      this.$http({
        url: "order/exportOrder",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        params: this.queryInfo,
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          //设置连接
          link.href = URL.createObjectURL(blob);
          link.download = `订单列表${this.currentdate}.xlsx`;
          document.body.appendChild(link);
          //模拟点击事件
          link.click();
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // 当前日期
    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate(); // 获取当前日(1-31)
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      if (month >= 1 && month <= 9) month = "0" + month; // 如果月份是个位数，在前面补0
      if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate; // 如果日是个位数，在前面补0
      this.currentdate = `${year}${month}${strDate}${hour}${minute}${second}`;
    },
    async updateSelect() {
      this.$forceUpdate();
    },

    //保存清除订单数据时间
    // async orderClearTimeSave() {
    //   let parms = {
    //     moduleName:"orderManagerWeb"
    //   }
    //   const { data: res } = await this.$http.post("orderClear/save", parms);
    //   if (res.code === 200) {
    //     this.$message.success('操作成功')
    //     ;
    //     this.getOrderList()
    //   } else {
    //     this.$message.error(res.message)
    //   }
    // },

    //播放视频
    handlePlayVideo(param) {
      window.open(param, "_blank");
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    // orderDateRangeValue(){
    //   //解决时间选择器清空后 绑定值为null问题
    //   if(!this.orderDateRangeValue){
    //     this.orderDateRangeValue = '';
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   }
    //   else{
    //     if(this.orderDateRangeValue.length>0){
    //       this.queryInfo.createTimeStart = this.orderDateRangeValue;
    //       this.queryInfo.createTimeEnd = this.orderDateRangeValue;
    //     }
    //   }
    //
    // },
    // shipDateRangeValue(){
    //   if(!this.shipDateRangeValue){
    //     this.shipDateRangeValue =[];
    //     this.queryInfo.sendTimeStart = '';
    //     this.queryInfo.sendTimeEnd = '';
    //   }
    //   else{
    //     if(this.shipDateRangeValue.length>0){
    //       this.queryInfo.sendTimeStart = this.shipDateRangeValue[0];
    //       this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1];
    //     }
    //   }
    // }
  },
  computed: {
    order1() {
      if (!sessionStorage.getItem("token")) {
        return false;
      }
    },
  },
  // 离开页面
  deactivated() {
    const bodyWrapper = this.$refs.multipleTable.$el.querySelector(".el-table__body-wrapper");
    bodyWrapper.removeEventListener("scroll", this.scrollListener);
  },
};
</script>

<style lang="less" scoped>
/deep/
  /*去除upload组件过渡效果*/
.el-upload-list__item {
  transition: none !important;
}

.bigimg /deep/ ul li {
  width: 100%;
  height: auto;
}

.bigimg /deep/ .el-upload--picture-card {
  display: none;
}

// ::v-deep(.el-table__expand-icon){
//   height: 80px;
// }

.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.split-col {
  padding-right: 20px;
}

.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container-status {
  text-align: left !important;
}

.mark {
  background: #dbdb86;
  text-align: left;
  margin-bottom: 10px;
}

.el-icon-close {
  cursor: pointer;
}

.dialog-account {
  display: flex;
  flex-wrap: wrap;

  /deep/.el-radio {
    width: 28%;
    margin-bottom: 10px;
  }
}
.font-style {
  display: flex;
  justify-content: center;
  width: 100%;
  // justify-content: space-between;
  .left {
    display: flex;
    justify-content: flex-end;
    width: 58px;
    // min-width: 40px;
  }
  .right {
    max-width: calc(100% - 90px);
    min-width: 25px;
    text-align: left;
    flex: 1;
    // display: flex;
    // justify-content: flex-end;
    // flex-wrap: nowrap;
  }
  .text-over {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.font-style1 {
  display: flex;
  justify-content: center;
  // justify-content: space-between;
  .left {
    display: flex;
    justify-content: flex-end;
    // width: 50px;
    min-width: 70px;
  }
  .right {
    min-width: 10px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.flex-column {
  display: flex;
  flex-direction: column;
}

::v-deep.el-form-item--mini .el-form-item__label {
  padding-right: 0 !important;
  line-height: 20px !important;
}
::v-deep.el-form-item--mini .el-form-item__content {
  line-height: 20px !important;
  max-width: 160px;
  padding-right: 5px;
  box-sizing: border-box;
}
::v-deep.el-form-item {
  margin-bottom: 0 !important;
}
::v-deep.el-table_1_column_8.is-center {
  width: 230px !important;
}
::v-deep.flex-column {
  max-width: 220px;
}
.text-over {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  text-align: left;
}
.btn-action {
  width: 100px;
}
::v-deep(.el-table__expanded-cell) {
  padding: 20px 15px;
}
</style>
